import { FC } from 'react'
import {
  List,
  Datagrid,
  TextField,
  DateField,
  FunctionField,
  ListProps,
  TopToolbar,
  CreateButton,
} from 'react-admin'
import { Chip, Box } from '@mui/material'
import { PrognoseSetResponse } from '../../types/apiRequests'
import { statusColors, publicatieStatusColors } from '../../components/prognose'

const ListActions = () => (
  <TopToolbar>
    <CreateButton label="Nieuwe Gebiedsprognose" />
  </TopToolbar>
)

const GebiedsprognoseList: FC<ListProps> = (props) => (
  <List
    {...props}
    exporter={false}
    actions={<ListActions />}
    sort={{ field: 'created', order: 'DESC' }}
  >
    <Datagrid bulkActionButtons={false} rowClick="show">
      <TextField source="naam" label="Naam" />
      <FunctionField
        label="Periode"
        render={(record: PrognoseSetResponse) =>
          record ? `${record.bjaar} - ${record.ejaar}` : ''
        }
      />
      <FunctionField
        label="Status"
        render={(record: PrognoseSetResponse) => {
          if (!record) return null
          const pubStatus = record.publicatie_status || 'concept'
          return (
            <Box sx={{ display: 'flex', gap: 0.5 }}>
              <Chip
                label={pubStatus.charAt(0).toUpperCase() + pubStatus.slice(1)}
                color={publicatieStatusColors[pubStatus] || 'default'}
                size="small"
              />
              <Chip
                label={record.status}
                color={statusColors[record.status] || 'default'}
                size="small"
                variant="outlined"
              />
            </Box>
          )
        }}
      />
      <DateField source="created" label="Aangemaakt" showTime />
    </Datagrid>
  </List>
)

export default GebiedsprognoseList
